import { render, staticRenderFns } from "./ContainerForm.vue?vue&type=template&id=612c3080"
import script from "./ContainerForm.vue?vue&type=script&lang=js"
export * from "./ContainerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports